const itemCode = ''
console.log(itemCode)
const leftnav = [
  {
    data: {
      menuName: "认证中心菜单",
      menuCode: 'auth-menu',
      icon: 'icon-ico-dingdanguanli-congyezigeguanli'
    },
    children: [
      {
        data: {
          menuName: "认证权限",
          menuCode: 'auth-permission',
          // icon: require('./img/icon8.png'),
        },

        children: [
          {
            data: {
              menuName: "用户管理",
              menuUrl: "/userManagement",
              menuCode: 'userManagement'
            },
          },

          {
            data: {
              menuName: "用户组管理",
              menuUrl: "/userGroupManagement",
              menuCode: 'userGroupManagement'
            },
          },
          {
            data: {
              menuName: "角色管理",
              menuUrl: "/roleManagement",
              menuCode: 'roleManagement'
            },
          },
          {
            data: {
              menuName: "部门管理",
              menuUrl: "/departmentManagement",
              menuCode: 'departmentManagement'
            },
          }
        ],
      },
      {
        data: {
          menuName: "系统管理",
          menuCode: 'system-manage',
          // icon: require('./img/setting.png'),
        },
        children: [
          {
            data: {
              menuName: "字典管理",
              menuUrl: "/dictionaryManagement",
              menuCode: 'dictionaryManagement'
            },
          },
          {
            data: {
              menuName: "菜单管理",
              menuUrl: "/menuManagement",
              menuCode: 'menuManagement'
            },
          },
        ],
      },

      {
        data: {
          menuName: "事项信息管理",
          menuCode: 'matterInfo',
          // icon: require('./img/point.png'),
        },
        children: [],
      },
    ],
  },
]
export default leftnav



// WEBPACK FOOTER //
// ./src/pages/layout/leftnav1.js